<template>
    <div class="collapse">
        <div class="trigger is-flex is-align-items-center">
            <slot name="trigger"></slot>

            <div class="ml-auto"></div>
            <div class="indicator pointer" @click="$emit('input', !value)">
                <font-awesome-icon :icon="['fas', 'chevron-up']" v-if="value" />
                <font-awesome-icon :icon="['fas', 'chevron-down']" v-else />
            </div>
        </div>
        <Transition name="fade">
            <div class="collapse-content" v-show="value">
                <slot></slot>
            </div>
        </Transition>
    </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

library.add(faChevronUp);
library.add(faChevronDown);

export default {
    name: 'collapse',
    components: { FontAwesomeIcon },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 150ms ease-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
